module.exports = __webpack_public_path__ + "img/ic_nav_kingdom_normal.028eb79b.png";